import modelExtend from 'dva-model-extend'
import { basicModel, UPDATESTATE } from '@sisyphe/utils'
import * as api from 'services/store'

export default modelExtend(basicModel, {
  namespace: 'home',
  state: {
    spuList: [],
    categoryList: [],
  },
  reducers: {},
  effects: {
    /** 商城首页查询-App */
    *homepageQuery({ payload }, { call, put }) {
      const { data } = yield call(api.homepageQueryUsingPOST, payload)
      yield put({
        type: UPDATESTATE,
        payload: {
          spuList: data?.spuInfoDTOS,
        },
      })
      return data
    },
    /** 商品分类 */
    *echoProductConfig({ payload }, { call, put }) {
      const { data } = yield call(api.echoProductConfigUsingPOST_1, payload)
      yield put({
        type: UPDATESTATE,
        payload: {
          categoryList: data || [],
        },
      })
      return data
    },
  },
})
